<script lang="ts">
  import { CtaEntity } from "@shared/services/event_tracking/entities";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import CloudinaryImageService from "@shared/svelte/Modules/CloudinaryImageService";
  import DistributorCatalogDistributorContext from "@retailer/svelte/ProductLines/OrderActionBar/Cards//DistributorCatalogDistributorContext.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";

  import type { Distributor } from "@shared/types/Distributor";

  export let isLoading = true;
  export let distributors: Distributor[];
  const trackingParams = new CtaEntity({ service: "action_bar_add_distributors" });
</script>

<style>
  .icon-container {
    height: 36px;
    width: 36px;
    min-width: 36px;
  }
</style>

<div class="fizz-grid fizz-inset-vertical-8">
  {#if isLoading}
    {#each Array(3) as _}
      <Skeleton animate={true} height={36} width={180} ariaLabel="desktop-distributor-loading" />
    {/each}
  {:else}
    {#each distributors as distributor, i}
      <DistributorCatalogDistributorContext {distributor}>
        <UIRouterLink
          stateName={"layout.product_listing"}
          params={{ distributors: distributor.id }}
          classes="underline-hover cursor-pointer fizz-flex-row-8"
          useTrackClick={true}
          targetObjectType="content_card"
          useDiv={true}
          id={`distributor_${distributor.id}_link`}
        >
          <div class="fizz-bordered icon-container">
            {#if distributor.cloudinary_image_url}
              <img
                on:error={() => (distributor.cloudinary_image_url = null)}
                class="logo"
                src={CloudinaryImageService.getUrl(distributor.cloudinary_image_url, 75, 75)}
                alt="Logo"
              />
            {:else}
              <Icon type="DistributorLogoPlaceholder" extraStyles="height: 100%; width: 100%;" />
            {/if}
          </div>
          <p
            class="fizz-text-small fizz-text-black fizz-text-left"
            data-testId={`sorted-distributor-${i}`}
          >
            {distributor.name}
          </p>
        </UIRouterLink>
      </DistributorCatalogDistributorContext>
    {/each}
  {/if}
  <TrackingContext entities={trackingParams}>
    <UIRouterLink
      stateName="layout.accounts"
      classes="underline-hover cursor-pointer fizz-flex-row-8"
      useTrackClick={true}
      targetObjectType="content_card"
      useDiv={true}
    >
      <div class="fizz-grid-center fizz-bordered icon-container">
        <Icon type="Plus" fill="black" height={10} width={10} />
      </div>
      <p class="fizz-text-small fizz-text-left">Add more distributors</p>
    </UIRouterLink>
  </TrackingContext>
</div>
